import * as types from './types'
import trackApi from '../api'

export const actions = {
    async [types.ALIBI_FETCH]({commit}, data = null) {
        commit(types.ALIBI_SET_LOADING, true)
        const response = await trackApi.all(data)
        commit(types.ALIBI_OBTAIN, response.data.data)
        commit(types.ALIBI_META, response.data.meta)
        commit(types.ALIBI_SET_LOADING, false)
    },
}
